var prodcat = prodcat || {};
var presentAfterpay = presentAfterpay || {};
var Model = Model || {};
var site = site || {};

(function ($) {
  // @todo we need slick cleanup
  Drupal.behaviors.sppProductLayout = {
    initCarousel: function (context) {
      // images
      var $sppImages = $('.product-full__image-carousel', context);
      var $carousel = $('.js-spp-carousel', $sppImages);
      var $sppThumbnails = $('.js-product-full-image-thumbs', context);
      var $badgeContainer = $('.js-product-badge', context);

      // SPP image Carousel
      $sppImages.each(function () {
        var thisFormatter = $(this);
        var carousel = thisFormatter.find('.js-spp-carousel');
        var arrowsDiv = thisFormatter.find('.carousel-controls');
        var dotsDiv = thisFormatter.find('.js-carousel-dots');
        var sppSlide = '.js-spp-carousel__slide';
        // case for custom slides count and dots for mobile
        var settings = {
          slide: sppSlide,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          appendArrows: arrowsDiv,
          appendDots: dotsDiv,
          dots: true,
          arrows: true,
          swipe: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                swipe: true
              }
            }
          ]
        };
        if (!Drupal.settings.common.pdp_modernized_design) {
          settings.centerMode = false;
          settings.variableWidth = false;
          settings.responsive[0].settings.centerMode = true;
          settings.responsive[0].settings.variableWidth = true;
        }
        $carousel.on('init', function () {
          if ($('.js-spp-carousel__slide', $sppImages).length === 1) {
            $carousel.addClass('single-carousel');
          }
        });

        if ($carousel.hasClass('slick-initialized')) {
          // if the slide was allready initialized, we don't need
          // to send accessibility again as it throws error if it tried
          // to initADA again
          settings.accessibility = false;
        } else {
          // Init this carousel with our settings
          $carousel.slick(settings);
          if (!Drupal.settings.common.pdp_modernized_design) {
            $('.js-spp-carousel__slide.slick-active', $sppImages)
            .prev()
            .addClass('spp-carousel__slide--hidden');
          }
        }
      });
      function hidePreviousSlide($slide) {
        $slide.removeClass('spp-carousel__slide--visible');
        $slide.addClass('spp-carousel__slide--hidden');
      }

      $carousel.on('afterChange', function (carousel, currentSlide, currentSlideIndex) {
        if (!Drupal.settings.common.pdp_modernized_design) {
          hidePreviousSlide($('.js-spp-carousel__slide.slick-active', $sppImages).prev());
        }
        if ($badgeContainer.length) {
          $badgeContainer.removeClass('hidden');
          if (currentSlideIndex !== 0) {
            $badgeContainer.addClass('hidden');
          }
        }
      });
      $carousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        if (!Drupal.settings.common.pdp_modernized_design) {
          $('.js-spp-carousel__slide', $sppImages).addClass('spp-carousel__slide--visible');
          if (Math.abs(nextSlide - currentSlide) === 1) {
            if (nextSlide - currentSlide > 0) {
              hidePreviousSlide($('.js-spp-carousel__slide.slick-active', $sppImages));
            } else {
              hidePreviousSlide($('.js-spp-carousel__slide.slick-active', $sppImages).prev().prev());
            }
          }
        }
      });

      // SPP Thumbnail Carousel
      $sppThumbnails.each(function () {
        var $thisFormatter = $(this);
        var $thumbsArrowDiv = $thisFormatter.find('.js-carousel-arrows');
        var $thumbInnerContent = $('.js-product-full-image-thumbs-content-inner', $thisFormatter);
        var $thumbsImages = $('.js-product-full-image-thumb', $thumbInnerContent);
        var thumbSlide = '.js-product-full-image-thumb';
        var $thumbWrapper;
        var settings = {
          slide: thumbSlide,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          appendArrows: $thumbsArrowDiv,
          swipe: false,
          vertical: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                swipe: true
              }
            }
          ]
        };

        if ($thumbInnerContent.hasClass('slick-initialized')) {
          settings.accessibility = false;
        } else {
          $thumbInnerContent.slick(settings);
        }

        $thumbsImages.first().addClass('active');
        $thumbWrapper = $('.js-product-full-image-thumb', $thisFormatter);
        $thumbWrapper.once().on('click', function (e) {
          var $sliderThumb = $(this);
          var $sliderImgSrc = $sliderThumb.find('img').attr('src');
          var $sliderImages = $thumbWrapper.find('img[src="' + $sliderImgSrc + '"]');
          var index;

          e.preventDefault();
          if ($sliderThumb.hasClass('active')) {
            return;
          }
          index = $sliderThumb.data('slick-index');
          $carousel.slick('slickGoTo', index);
          $thumbInnerContent.slick('slickGoTo', index);
          $sliderThumb.parent().find('.active').removeClass('active');
          $sliderImages.parent().addClass('active');
        });
      });

      $('.js-iln-listing-trigger', context).one('click', function (event) {
        event.preventDefault();
        $(this).slideUp();
        $(this).parent().find('.js-iln-listing-content').slideDown();
      });

      // Show aspirational copy on init if any
      Drupal.behaviors.sppProductLayout._handleAspirationalCopy(context);

      // Show/hide aspirational copy
      $('.carousel-controls')
        .once()
        .click(function () {
          Drupal.behaviors.sppProductLayout._handleAspirationalCopy(context);
        });
    },

    _handleAspirationalCopy: function (context) {
      if ($('.js-move-asp-copy', context).length > 0) {
        return false;
      }
      var $container = $('.js-product-full-image', context);
      var aspCpy = $container.data('asp-copy');

      $('.product-full__quote', context).remove();
      if (typeof aspCpy !== 'undefined') {
        setTimeout(function () {
          $('.product-full__image', context).append(
            '<div class="product-full__quote">' + aspCpy + '</div>'
          );
        }, 300);
      } else {
        $('.product-full__quote', context).remove();
      }
    },
    attach: function (context) {
      var $spp_container = $('.js-spp-content', context);
      var salon_takeover = $('.salon-takeover', context).length;

      if (salon_takeover) {
        $('.js-instore-container', $spp_container).remove();
      }
    }
  };

  $(document).on('product.skuSelect', '.js-product', function (event, skuBaseId) {
    var $product = $(this);
    var $imageContainer = $('.js-product-full-image', $product);
    var $unitPrice = $('.js-sku-unit-price', $product);
    $('.js-sku-menu-chip__option', this).removeClass('selected');
    $(`.js-sku-menu-chip__option[value=${skuBaseId}]`, this).addClass('selected');

    var sku = prodcat.data.getSku(skuBaseId);
    if (sku && $unitPrice.length) {
      $unitPrice.text(sku.formattedUnitPrice || '');
    }

    if (!$imageContainer.length) {
      return;
    }
    var prodData = prodcat.data.getProduct(sku.PRODUCT_ID);
    var skuLargeImage = sku.IMAGE_LARGE[0];
    var skuPrice = sku.formattedPrice.replace(/[^\d]/g, '');

    var altText = prodData.PROD_RGN_NAME || '';
    altText += ' ' + (prodData.PROD_RGN_SUBHEADING || '');
    altText = altText.trim();
    if (sku?.SHADENAME) {
      altText += ', ' + sku.SHADENAME;
    }
    if (sku?.PRODUCT_SIZE) {
      altText += ', ' + sku.PRODUCT_SIZE;
    }
    $imageContainer.find('img').attr('alt', altText);

    $imageContainer
      .find('.js-product-full-thumb-img.js-product-large-image--thumb')
      .attr('src', skuLargeImage);
    if (skuPrice !== null && typeof presentAfterpay.afterpayConfig === 'function') {
      presentAfterpay.afterpayConfig(skuPrice);
    }
  });

  /**
   * Carousel Initiation Event
   */
  $(document).on('product.initCarousel', '.js-product', function (e, $product) {
    Drupal.behaviors.sppProductLayout.initCarousel($product);
  });

  /* Aveda inventory visibility functionality*/

  function SingleProductPage($page) {
    this.$page = $page;
    this.$container = $('.js-product', this.$page);
    this.$slides = $('.js-product-slide', this.$page);
    this.$sliderThumbs = $('.js-product-thumb', this.$page);
    this.$tooltips = $('.js-tooltip', this.$page);
    this.$inStoreBtn = $('.js-check-in-store', this.$page);
    this.$inStoreCont = $('.js-instore-inv-container', this.$page);
    this.$cartBtn = $('.js-add-to-cart', this.$container);
  }

  SingleProductPage.prototype.setStoreCheck = function (e, sku) {
    $(document).trigger('instore:product:setDisplay', {
      activeSku: sku,
      $container: this.$inStoreCont,
      $cartBtn: this.$cartBtn
    });
  };

  SingleProductPage.prototype.setBopis = function () {
    var selectedSku = this.$container.data().skuBaseId;
    var skus = Model.PageData.get().skus.map(function (sku) {
      return sku.SKU_BASE_ID;
    });

    if (!site.Bopis || site.Bopis.getIsBipisInitialized()) {
      return false;
    }
    site.Bopis.initBopis(selectedSku, skus);
  };

  SingleProductPage.prototype.initStoreCheck = function () {
    $(document).on('instore:loaded', $.proxy(this.setStoreCheck, this));
  };

  SingleProductPage.prototype.initBopis = function () {
    $(document).on('instore:loaded', this.setBopis.bind(this));
  };
  /**
   * An init function that must be called manually.
   */
  SingleProductPage.prototype.init = function () {
    var isSalon = !!sessionStorage.getItem('SalonID');

    this.initStoreCheck();
    !isSalon && this.initBopis();
  };

  /**
   * [$page The target page to start the SPP on. This is used as a context for all selectors.]
   * @type {jQuery Object}
   */
  var $page = $('.spp__container');
  var spp = new SingleProductPage($page);

  spp.init();
})(jQuery);
